import React from "react";
import styled from "styled-components";
import Modal from "../../../../components/Modal";
import { Typography } from "@mui/material";

const MainContainer = styled.div`
  padding-bottom: 40px;
  min-height: 100px;
  width: 100%;
  .numberField {
    margin-top: 20px;
  }
  .responseContainer {
    margin-top: 12px;
    .listItem {
      display: flex;
      flex-direction: row;
      margin-left: 10px;
    }
  }
`;

const AlertModal = ({
  title,
  message,
  confirmTitle,
  cancelTitle,
  onCancel,
  onSubmit,
  isLoading,
}) => {
  return (
    <Modal
      onSubmit={() => onSubmit()}
      confirmTitle={confirmTitle ?? "Yes"}
      cancelTitle={cancelTitle ?? "No"}
      onCancel={onCancel}
      isLoading={isLoading}
    >
      <MainContainer>
        <Typography
          variant="h6"
          fontWeight={700}
          textAlign={"center"}
          width={"100%"}
          marginBottom={4}
        >
          {title ?? ""}
        </Typography>
        <Typography
          variant="Body1"
          textAlign={"center"}
          width={"100%"}
          fontWeight={400}
        >
          {message ?? ""}
        </Typography>
      </MainContainer>
    </Modal>
  );
};

export default AlertModal;
